import React, { useState } from "react"

import dayjs from "dayjs"
import { useHistory } from "react-router-dom"
import { gql, useQuery } from "urql"

import WithLoadingIndicator from "~tailwindui/Basics/WithLoadingIndicator"
import Table from "~tailwindui/Table/Table"

import LocalTime from "components/LocalTime"
import DataDateRange from "components/OrganizationAdmin/components/DataDateRange"
import Header from "components/OrganizationAdmin/components/DisplayableFormikForm/Header"

const StudentsPage = () => {
  const history = useHistory()

  const defaultStartingAt = dayjs().startOf("year")
  const defaultEndingAt = dayjs()
  const [startingAt, setStartingAt] = useState(defaultStartingAt)
  const [endingAt, setEndingAt] = useState(defaultEndingAt)

  const [page, setPage] = useState(1)
  const [result] = useQuery({
    query: studentsQuery,
    variables: { page, startingAt, endingAt },
  })

  return (
    <>
      <Header title="Students" />
      <DataDateRange
        startDate={startingAt}
        setStartDate={setStartingAt}
        endDate={endingAt}
        setEndDate={setEndingAt}
      />
      <WithLoadingIndicator result={result}>
        {({ data }) => (
          <>
            <Table
              data={data.viewer.organization.students}
              changePage={setPage}
              rowCallback={student => history.push(`/students/${student.id}`)}
              cols={[
                { header: "First Name", value: student => student.firstName },
                { header: "Last Name", value: student => student.lastName },
                { header: "School", value: student => student.school?.name },
                { header: "Grade", value: student => student.grade?.name },
                {
                  header: "No Shows",
                  value: student => student.rangedNoShowCount,
                },
                {
                  header: "Next Session",
                  value: student => (
                    <LocalTime
                      key="startsAt"
                      timestamp={student.nextSession?.startsAt}
                    />
                  ),
                },
              ]}
            />
          </>
        )}
      </WithLoadingIndicator>
    </>
  )
}

const studentsQuery = gql`
  query students(
    $page: Int!
    $attending: Boolean
    $startingAt: DateTime!
    $endingAt: DateTime!
  ) {
    viewer {
      organization {
        students: paginatedStudents(page: $page, attending: $attending) {
          currentPage
          totalPages
          data {
            id
            firstName
            lastName
            school {
              id
              name
            }
            grade {
              id
              name
            }
            rangedNoShowCount(startDate: $startingAt, endDate: $endingAt)
            nextSession {
              id
              startsAt
            }
          }
        }
      }
    }
  }
`

export default StudentsPage
